export default __webpack_public_path__ + "static/media/Legguards of the Atlantean.b16656fe.jpg";